export var EUserPermission;
(function (EUserPermission) {
    EUserPermission["READ_ALL"] = "read:all";
    EUserPermission["WRITE_ALL"] = "write:all";
})(EUserPermission || (EUserPermission = {}));
